import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { LightDarkGreyBox, LightGreyBox } from "../../styled";
import { StyledGreyBadge } from "../../styled/badge";

import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import ModalHeader from "../../modals/modalHeader";
import { CustomModalRoot } from "../../styled/modal";
import { formatFinance } from "../../../utils/formatters";

export default function CustomerTopProductsList({
  products,
  show,
  closeModal,
}) {
  return (
    <Modal
      aria-labelledby="alert-modal"
      aria-describedby="shows-alert-message"
      open={show}
      onClose={closeModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{
        zIndex: 9000,
        border: "none",
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Fade in={show}>
        <CustomModalRoot
          top={40}
          left={50}
          width={50}
          height={75}
          overflow={"auto"}
        >
          <ModalHeader onClose={closeModal} label="Top 10 Produtos" />
          <Box sx={{ p: 2 }}>
            <LightDarkGreyBox
              display="flex"
              justifyContent="space-between"
              sx={{ mb: 2 }}
            >
              <StyledGreyBadge>
                <Typography>Produto</Typography>
              </StyledGreyBadge>

              <Stack direction="row" spacing={2}>
                <StyledGreyBadge>
                  <Typography>Unidade</Typography>
                </StyledGreyBadge>
                <StyledGreyBadge>
                  <Typography>Quantidade</Typography>
                </StyledGreyBadge>
                <StyledGreyBadge>
                  <Typography>Total</Typography>
                </StyledGreyBadge>
              </Stack>
            </LightDarkGreyBox>
            {products.map((product) => (
              <LightGreyBox
                display="flex"
                justifyContent="space-between"
                sx={{ mb: 1 }}
              >
                <Typography>{product.title}</Typography>

                <Stack direction="row" spacing={2}>
                  <StyledGreyBadge>
                    <Typography>{formatFinance(product.un_price)}un</Typography>
                  </StyledGreyBadge>
                  <StyledGreyBadge>
                    <Typography>x{product.total_quantity}</Typography>
                  </StyledGreyBadge>
                  <StyledGreyBadge>
                    <Typography>
                      {formatFinance(product.total_price)}
                    </Typography>
                  </StyledGreyBadge>
                </Stack>
              </LightGreyBox>
            ))}
          </Box>
        </CustomModalRoot>
      </Fade>
    </Modal>
  );
}
